export const themePageRef = 'theme-page';
